import { render, staticRenderFns } from "./notFoundComponent.vue?vue&type=template&id=b6343382&"
import script from "./notFoundComponent.vue?vue&type=script&lang=js&"
export * from "./notFoundComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports